import React, { type FC, useEffect, useState } from "react";
import { useTracking } from "@edreamsodigeo/frontend-core";

import {
  TRACKING_ACTION,
  TRACKING_CATEGORY,
  TRACKING_LABEL_ONLOAD,
} from "./config/tracking";
import type { UserVerificationModalProps } from "./contract";
import UserVerificationModalContent from "./UserVerificationModalContent";
import UserVerificationModalHeader from "./UserVerificationModalHeader";
import UserVerificationSystemModal from "./UserVerificationSystemModal";

const UserVerificationModal: FC<UserVerificationModalProps> = ({ onClick }) => {
  const [showModal, setShowModal] = useState(true);
  const { trackEvent } = useTracking();

  const handleClose = (): void => {
    setShowModal(false);
  };

  useEffect(() => {
    if (showModal) {
      trackEvent({
        category: TRACKING_CATEGORY,
        action: TRACKING_ACTION,
        label: TRACKING_LABEL_ONLOAD,
      });
    }
  }, [showModal, trackEvent]);

  return (
    <UserVerificationSystemModal isOpen={showModal}>
      <UserVerificationModalHeader />
      <UserVerificationModalContent onClick={onClick} onClose={handleClose} />
    </UserVerificationSystemModal>
  );
};

export default UserVerificationModal;
